import { Injectable, inject } from '@angular/core';
import { I18NService } from '@core';
import { ALAIN_I18N_TOKEN } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd/message';

import { HttpService } from '../http/http.service';
import { ConstantUtil } from '../util/constant.util';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  private readonly message = inject(NzMessageService);
  private readonly httpService = inject(HttpService);
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);

  /**
   * 通用文件下载方法
   * @param fileId 文件ID
   * @param downloadUrl 完整的下载URL
   * @param fileName 文件名（可选）
   */
  downloadFile(fileId: string, fileName?: string): void {
    if (!fileId) {
      this.message.error(this.i18n.fanyi('download.file-id-not-exist'));
      return;
    }
    const apiPath = `${ConstantUtil.VERSION_CONTROL_DOWNLOAD}/${fileId}`;
    const filename = fileName || this.i18n.fanyi('download.default-filename');

    // 以 POST 方式获取二进制并触发下载
    this.httpService.postBlob(apiPath, null).subscribe({
      next: (blob: Blob) => {
        try {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          // 释放对象 URL
          setTimeout(() => URL.revokeObjectURL(url), 500);
          this.message.success(this.i18n.fanyi('download.start-download'));
        } catch (e) {
          this.message.error(this.i18n.fanyi('download.download-failed'));
        }
      },
      error: () => {
        this.message.error(this.i18n.fanyi('download.download-failed'));
      }
    });
  }

  /**
   * 通过完整URL下载文件
   * @param url 完整的下载URL
   * @param fileName 文件名（可选）
   */
  downloadFileByUrl(url: string, fileName?: string): void {
    if (!url) {
      this.message.error(this.i18n.fanyi('download.download-link-not-exist'));
      return;
    }

    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = fileName || this.i18n.fanyi('download.default-filename');

    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
    }, 100);

    this.message.success(this.i18n.fanyi('download.start-download'));
  }
}
